export const sumValuesWithCurrency = (data) => `${data.order_items.reduce(
	(prev, next) => prev + next.price,
	0,
)}
  ${data.currency}`;
